var $ = require('jquery');
require('bootstrap');
require('jquery-countto');
require('./utilities/class_enlarge.js');
require('./utilities/class_count.js');
require('./utilities/pdw_mobile_menu.js');

$(function() {

    window.dispatchEvent(new Event('resize'));

    $(document).ready(function(){
        $('.slider-fields h4').click(function(){
            $('h4').removeClass("active");
            $(this).addClass("active");
        });
    });


    //Ajout class active menu custom
    jQuery(function($) {
        var path = window.location.href; // because the 'href' property of the DOM element is the absolute path
        $('ul a').each(function() {
            if (this.href === path) {
                $(this).addClass('active');
            }
        });
    });

    //Resize logo on scroll
    /*
    window.onscroll = function() {
        resizeLogo()
    };

    function resizeLogo() {
        var Logo = document.getElementById("logo")
        if (document.body.scrollTop > 5 || document.documentElement.scrollTop > 5) {
            Logo.style.width = '200px';
        } else {
            Logo.style.width = '325px';
        }
    }
    */

});


// Script scroll to top

//
 jQuery(document).ready(function($){
  var offset = 100;
  var speed = 250;
   var duration = 500;
    $(window).scroll(function(){
       if ($(this).scrollTop() < offset) {
           $('.topbutton') .fadeOut(duration);
       } else {
           $('.topbutton') .fadeIn(duration);
      }
   });
   $('.topbutton').on('click', function(){
       $('html, body').animate({scrollTop:0}, speed);
       return false;
   });
 });







